export default "__VITE_ASSET__d2924410__"